import { useDispatch, batch } from 'react-redux';
import {
  fetchFeed,
  fetchGroups,
  uploadMedia,
  fetchUsers,
  fetchMoreFeed,
  uploadMediaUrl,
  createFeedPost,
  createFeedPostComment,
  setEditModal,
  createFeedPostCommentReply,
  editPost,
  editFeedPostComment,
  editFeedPostCommentReply,
  deleteFeedPost,
  deleteFeedPostComment,
  deleteFeedPostCommentReply,
  fetchFeedPost,
  fistBumpFeedPost,
  fistBumpComment,
  fistBumpReply,
  setIsReplyActivatedRedux,
} from '../../ducks/feedActions';
import { feedTracker } from '../../../../shared/utils/amplitudeHelper';

const useFeed = () => {
  const dispatch = useDispatch();

  const handleFetchFeed = (accountCode, groupIds = [], searchString = '') => {
    dispatch(fetchFeed(accountCode, groupIds, searchString));
  };

  const handleFetchGroups = (accountCode) => {
    dispatch(fetchGroups(accountCode));
  };

  const handleUploadMedia = (values) => {
    dispatch(uploadMedia(values));
    feedTracker('Normal Mode', 'Media uploaded');
  };

  const handleUploadMediaUrl = (mediaUrlOb, activeMediaBarOb = {}) => {
    dispatch(uploadMediaUrl(mediaUrlOb, activeMediaBarOb));
    feedTracker('Normal Mode', 'GIF uploaded');
  };

  const handleFetchUsers = (accountCode) => {
    dispatch(fetchUsers(accountCode));
  };

  const handleFetchMoreFeed = (accountCode, groupIds = [], searchString = '') => {
    dispatch(fetchMoreFeed(accountCode, groupIds, searchString));
  };

  const handleCreateFeedPost = (accountCode, newPostOb) => {
    dispatch(createFeedPost(accountCode, newPostOb));
  };

  const handleCreateFeedPostComment = (values) => {
    dispatch(createFeedPostComment(values));
  };

  const handleCreateFeedPostCommentReply = (values) => {
    batch(() => {
      dispatch(createFeedPostCommentReply(
        values,
      ));
      dispatch(setIsReplyActivatedRedux({}));
    });
  };

  const handleSetEdit = (feedObject) => {
    dispatch(setEditModal(feedObject));
  };

  const handleEditPost = (values) => {
    dispatch(editPost(values));
  };

  const handleEditFeedPostComment = (values) => {
    dispatch(editFeedPostComment(values));
  };

  const handleEditFeedPostCommentReply = (values) => {
    dispatch(editFeedPostCommentReply(values));
  };

  const handleDeleteFeedPost = (values) => {
    dispatch(deleteFeedPost(values));
  };

  const handleDeleteFeedPostComment = (values) => {
    dispatch(deleteFeedPostComment(values));
  };

  const handleDeleteFeedPostCommentReply = (values) => {
    dispatch(deleteFeedPostCommentReply(values));
  };

  const handleFetchFeedPost = (values) => {
    dispatch(fetchFeedPost(values));
  };

  const handleFistBumpFeedPost = (values) => {
    dispatch(fistBumpFeedPost(values));
  };

  const handleFistBumpComment = (values) => {
    dispatch(fistBumpComment(values));
  };

  const handleFistBumpReply = (
    values,
  ) => {
    dispatch(fistBumpReply(
      values,
    ));
  };

  return {
    handleFetchFeed,
    handleFetchGroups,
    handleUploadMedia,
    handleFetchUsers,
    handleFetchMoreFeed,
    handleUploadMediaUrl,
    handleCreateFeedPost,
    handleCreateFeedPostComment,
    handleSetEdit,
    handleCreateFeedPostCommentReply,
    handleEditPost,
    handleEditFeedPostComment,
    handleEditFeedPostCommentReply,
    handleDeleteFeedPost,
    handleDeleteFeedPostComment,
    handleDeleteFeedPostCommentReply,
    handleFetchFeedPost,
    handleFistBumpFeedPost,
    handleFistBumpComment,
    handleFistBumpReply,
  };
};

export default useFeed;
